import { graphql } from 'react-relay';

export const taglineLinkFragment = graphql`
    fragment TaglineLink_tagLineLink on TaglineLink {
        tagline
        text
        title
        url
    }
`;
